/* eslint-disable sonarjs/no-duplicate-string */
export const campaignTableContent = {
  content: [
    { name: 'NO SKP', isActive: true, keyValue: 'skp_no', type: 'text' },
    {
      name: 'START DATE',
      isActive: true,
      keyValue: 'start_date',
      type: 'date',
      minWidth: '200px',
    },
    {
      name: 'END DATE',
      isActive: true,
      keyValue: 'end_date',
      type: 'date',
      minWidth: '200px',
    },
    {
      name: 'CAMPAIGN START DATE',
      isActive: true,
      keyValue: 'start_date_campaign',
      type: 'date',
      minWidth: '200px',
    },
    {
      name: 'CAMPAIGN END DATE',
      isActive: true,
      keyValue: 'end_date_campaign',
      type: 'date',
      minWidth: '200px',
    },
    {
      name: 'CAMPAIGN NAME',
      isActive: true,
      keyValue: 'campaign_name',
      type: 'campaign_name',
      minWidth: '200px',
    },
    {
      name: 'PROMOTION TYPE',
      isActive: true,
      keyValue: 'promotion_type',
      type: 'promotion_type',
      minWidth: '200px',
    },
    {
      name: 'VENDOR NAME',
      isActive: true,
      keyValue: 'vendor_name',
      type: 'text',
      minWidth: '200px',
    },
    {
      name: 'STATUS SKP',
      isActive: true,
      keyValue: 'status',
      type: 'text',
      minWidth: '200px',
    },
    {
      name: 'STATUS UPLOAD PROOF',
      isActive: true,
      keyValue: 'is_uploaded_proof',
      type: 'upload_status',
      minWidth: '200px',
    },
    {
      name: 'STATUS DOWNLOAD',
      isActive: true,
      keyValue: 'is_campaign_download',
      type: 'download_status',
      minWidth: '200px',
    },
    {
      name: 'ACTION',
      isActive: true,
      keyValue: '',
      type: 'action',
      minWidth: '200px',
    },
  ],
  actions: [
    {
      name: 'Detail SKP',
      value: 'detail',
    },
    {
      name: 'Download SKP',
      value: 'download',
    },
  ],
}

export const financeTableContent = {
  content: [
    { name: 'NO SKP', isActive: true, keyValue: 'skp_no', type: 'text' },
    {
      name: 'START DATE',
      isActive: true,
      keyValue: 'start_date',
      type: 'date',
      minWidth: '200px',
    },
    {
      name: 'END DATE',
      isActive: true,
      keyValue: 'end_date',
      type: 'date',
      minWidth: '200px',
    },
    {
      name: 'CAMPAIGN START DATE',
      isActive: true,
      keyValue: 'start_date_campaign',
      type: 'date',
      minWidth: '200px',
    },
    {
      name: 'CAMPAIGN END DATE',
      isActive: true,
      keyValue: 'end_date_campaign',
      type: 'date',
      minWidth: '200px',
    },
    {
      name: 'CAMPAIGN NAME',
      isActive: true,
      keyValue: 'campaign_name',
      type: 'campaign_name',
      minWidth: '200px',
    },
    {
      name: 'PROMOTION TYPE',
      isActive: true,
      keyValue: 'promotion_type',
      type: 'promotion_type',
      minWidth: '200px',
    },
    {
      name: 'VENDOR NAME',
      isActive: true,
      keyValue: 'vendor_name',
      type: 'text',
      minWidth: '200px',
    },
    {
      name: 'BUDGET SKP',
      isActive: true,
      keyValue: 'budget_skp',
      type: 'currency',
      minWidth: '200px',
    },
    {
      name: 'STATUS UPLOAD ACTUAL CLAIM',
      isActive: true,
      keyValue: 'is_uploaded_actual_claim',
      type: 'upload_status',
      minWidth: '200px',
    },
    {
      name: 'STATUS APPROVED ACTUAL CLAIM',
      isActive: true,
      keyValue: 'is_approved_actual_claim',
      type: 'approved_status',
      minWidth: '200px',
    },
    {
      name: 'STATUS SKP',
      isActive: true,
      keyValue: 'status',
      type: 'text',
      minWidth: '200px',
    },
    {
      name: 'REJECTED REASON',
      isActive: true,
      keyValue: 'reject_reason',
      type: 'text',
      minWidth: '200px',
    },
    {
      name: 'ACTION',
      isActive: true,
      keyValue: '',
      type: 'action',
      minWidth: '200px',
    },
  ],
  actions: [
    {
      name: 'Detail SKP',
      value: 'detail',
    },
    {
      name: 'Archive SKP',
      value: 'archive',
    },
    {
      name: 'Reopen SKP',
      value: 'reopen',
    },
    {
      name: 'Download SKP',
      value: 'download',
    },
  ],
}

export const sourcingTableContent = {
  content: [
    { name: 'NO SKP', isActive: true, keyValue: 'skp_no', type: 'text' },
    {
      name: 'START DATE',
      isActive: true,
      keyValue: 'start_date',
      type: 'date',
      minWidth: '200px',
    },
    {
      name: 'END DATE',
      isActive: true,
      keyValue: 'end_date',
      type: 'date',
      minWidth: '200px',
    },
    {
      name: 'CAMPAIGN START DATE',
      isActive: true,
      keyValue: 'start_date_campaign',
      type: 'date',
      minWidth: '200px',
    },
    {
      name: 'CAMPAIGN END DATE',
      isActive: true,
      keyValue: 'end_date_campaign',
      type: 'date',
      minWidth: '200px',
    },
    {
      name: 'CAMPAIGN NAME',
      isActive: true,
      keyValue: 'campaign_name',
      type: 'campaign_name',
      minWidth: '200px',
    },
    {
      name: 'PROMOTION TYPE',
      isActive: true,
      keyValue: 'promotion_type',
      type: 'promotion_type',
      minWidth: '200px',
    },
    {
      name: 'VENDOR NAME',
      isActive: true,
      keyValue: 'vendor_name',
      type: 'text',
      minWidth: '200px',
    },
    {
      name: 'STATUS SKP',
      isActive: true,
      keyValue: 'status',
      type: 'text',
      minWidth: '180px',
    },
    {
      name: 'STATUS UPLOAD ACTUAL CLAIM',
      isActive: true,
      keyValue: 'is_uploaded_actual_claim',
      minWidth: '200px',
      type: 'upload_status',
    },
    {
      name: 'STATUS APPROVED ACTUAL CLAIM',
      isActive: true,
      keyValue: 'is_approved_actual_claim',
      minWidth: '180px',
      type: 'approved_status',
    },
    {
      name: 'REJECTED REASON',
      isActive: true,
      keyValue: 'reject_reason',
      minWidth: '200px',
      type: 'number',
    },
    {
      name: 'ACTION',
      isActive: true,
      keyValue: '',
      type: 'action',
      minWidth: '200px',
    },
  ],
  actions: [
    {
      name: 'Lihat / Edit SKP',
      value: 'detail',
    },
    {
      name: 'Duplicate SKP',
      value: 'duplicate new',
    },
    {
      name: 'Delete SKP',
      value: 'delete',
    },
  ],
}

export const internalTableContent = {
  content: [
    { name: 'NO SKP', isActive: true, keyValue: 'skp_no', type: 'text' },
    {
      name: 'START DATE',
      isActive: true,
      keyValue: 'start_date',
      type: 'date',
      minWidth: '200px',
    },
    {
      name: 'END DATE',
      isActive: true,
      keyValue: 'end_date',
      type: 'date',
      minWidth: '200px',
    },
    {
      name: 'CAMPAIGN START DATE',
      isActive: true,
      keyValue: 'start_date_campaign',
      type: 'date',
      minWidth: '200px',
    },
    {
      name: 'CAMPAIGN END DATE',
      isActive: true,
      keyValue: 'end_date_campaign',
      type: 'date',
      minWidth: '200px',
    },
    {
      name: 'ACTIVITY NAME',
      isActive: true,
      keyValue: 'campaign_name',
      type: 'text',
      minWidth: '200px',
    },
    {
      name: 'PROMOTION TYPE',
      isActive: true,
      keyValue: 'promotion_type',
      type: 'promotion_type',
      minWidth: '200px',
    },
    {
      name: 'STATUS SKP',
      isActive: true,
      keyValue: 'status',
      type: 'text',
      minWidth: '180px',
    },
    {
      name: 'ACTION',
      isActive: true,
      keyValue: '',
      type: 'action',
      minWidth: '200px',
    },
  ],
  actions: [
    {
      name: 'Detail SKP',
      value: 'detail',
    },
    {
      name: 'Edit SKP',
      value: 'edit',
    },
    {
      name: 'Duplicate SKP',
      value: 'duplicate',
    },
    {
      name: 'Delete SKP',
      value: 'delete',
    },
    {
      name: 'Archive SKP',
      value: 'archive',
    },
    {
      name: 'Reopen SKP',
      value: 'reopen',
    },
    {
      name: 'Download SKP',
      value: 'download',
    },
  ],
}

export const syaratKetentuanTableContent = {
  content: [
    { name: 'JUDUL', isActive: true, keyValue: 'tnc_title', type: 'text', minWidth: '200px' },
    {
      name: 'TIPE PROMOSI',
      isActive: true,
      keyValue: 'promotion_type',
      type: 'promotion_type',
    },
    {
      name: 'SYARAT KETENTUAN',
      isActive: true,
      keyValue: 'tnc_description',
      type: 'text',
      minWidth: '500px',
    },
    {
      name: 'END DATE',
      isActive: true,
      keyValue: 'created_at',
      type: 'date-syarat-ketentuan',
    },
    {
      name: 'STATUS',
      isActive: true,
      keyValue: 'tnc_status',
      type: 'text',
    },
    {
      name: 'ACTION',
      isActive: true,
      keyValue: '',
      type: 'add_edit_action',
      minWidth: '200px',
    },
  ],
}
